import axios from 'axios'
import config from './config'

export default class ConnectionPointService {
    serviceConfig = { ...config }

    constructor(overrideConfig) {
        this.serviceConfig = { ...this.serviceConfig, ...overrideConfig }
    }

    getThematics() {
        return axios.get(this.serviceConfig.getThematics)
    }

    getClasifications(thematicId) {
        return axios.get(this.serviceConfig.getClasifications, {
            params: { thematic_id: thematicId }
        })
    }

    getSubCategories(clasificationId) {
        return axios.get(this.serviceConfig.getSubCategories, {
            params: {
                clasification_id: clasificationId
            }
        })
    }

    getTags(subCategoryId) {
        return axios.get(this.serviceConfig.getTags, {
            params: {
                sub_clasification_id: subCategoryId
            }
        })
    }

    getRegions() {
        return axios.get(this.serviceConfig.getRegions)
    }

    getMunicipalities() {
        return axios.get(this.serviceConfig.getMunicipalities)
    }

    getActionsPermission() {
        return axios.get(this.serviceConfig.getActionsPermission)
    }


    getStaffFunctions() {
        return axios.get(this.serviceConfig.getStaffFunctions)
    }

    getSchoolLevels() {
        return axios.get(this.serviceConfig.getSchoolLevels)
    }

    getSchoolTurns() {
        return axios.get(this.serviceConfig.getSchoolTurns)
    }

    getSchoolCycles() {
        return axios.get(this.serviceConfig.getSchoolCycles)
    }

    getProjects() {
        return axios.get(this.serviceConfig.getProjects)
    }

    getRamales() {
        return axios.get(this.serviceConfig.getRamales)
    }

    getVrfs() {
        return axios.get(this.serviceConfig.getVrfs)
    }

    getRadiobases() {
        return axios.get(this.serviceConfig.getRadiobases)
    }

    getClusters() {
        return axios.get(this.serviceConfig.getClusters)
    }

    getConnectionTypes() {
        return axios.get(this.serviceConfig.getConnectionTypes)
    }

    getConnectionModalities() {
        return axios.get(this.serviceConfig.getConnectionModalities)
    }

    getModalities() {
        return axios.get(this.serviceConfig.getModalities)
    }

    getOlts() {
        return axios.get(this.serviceConfig.getOlts)
    }

    getStaff(params) {
        return axios.get(this.serviceConfig.getStaff, { params })
    }

    saveConnectionPoint(connectionPoint) {
        return axios.post(this.serviceConfig.connectionPoints, connectionPoint)
    }

    updateConnectionPoint(id, connectionPoint) {
        return axios.put(`${this.serviceConfig.connectionPoints}/${id}`, connectionPoint)
    }

    updateConnectionPointFromTickets(id, connectionPoint) {
        return axios.put(`${this.serviceConfig.tickets}/${id}/updateConnectionPoint`, connectionPoint)
    }

    getConnectionPoints(filters) {
        return axios.get(this.serviceConfig.connectionPoints, {
            params: filters,
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
    }

    getConnectionPointById(id) {
        return axios.get(`${this.serviceConfig.connectionPoints}/${id}`)
    }

    deleteConnectionPoint(id) {
        return axios.delete(`${this.serviceConfig.connectionPoints}/${id}`)
    }

    updateStatusConnectionPoint(connectionPointId, changes) {        
        return axios.put(`${this.serviceConfig.connectionPoints}/${connectionPointId}/status`, changes)
    }

    deleteStaffMember(connection_point_id, staff_member_id) {
        return axios.delete(
            `${this.serviceConfig.connectionPoints}/${connection_point_id}/staffMembers/${staff_member_id}`
        )
    }

    updateLocation(connection_point_id, location) {
        return axios.put(`${this.serviceConfig.connectionPoints}/${connection_point_id}/ubicacion`, location)
    }

    toggleFavorite(connection_point_id, staff_member_id) {
        return axios.put(
            `${this.serviceConfig.connectionPoints}/${connection_point_id}/staffMembers/${staff_member_id}/favoriteToggle`
        )
    }

    saveStaffMembers(connection_point_id, data) {
        return axios.put(`${this.serviceConfig.connectionPoints}/${connection_point_id}/staffMembers`, data)
    }

    downloadList(params) {
        return axios.get(this.serviceConfig.downloadList, {
            params,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: '*/*'
            },
            responseType: 'blob'
        })
    }

    getConnectionPointsChunk(params) {
        return axios.get(this.serviceConfig.getConnectionPointsChunk, { params })
    }

    createAction(data) {
        return axios.post(this.serviceConfig.createAction, data)
    }

    getAction(id) {
        return axios.get(`${this.serviceConfig.getAction}/${id}`)
    }
}
